import React from 'react'

import { TableHead, TableRow } from 'components/Table'
import { HeadCell } from './HeadCell'

export const TriageTableHead = ({ orderBy, orientation, onOrder }) => {
  return (
    <TableHead>
      <TableRow style={{ borderBottom: '2px solid #778888' }}>
        <HeadCell
          heading="customerName"
          onOrder={() => onOrder('customerName')}
          orderBy={orderBy}
          orientation={orientation}
        />
        <HeadCell
          heading="customerTaxDocument"
          onOrder={() => onOrder('customerTaxDocument')}
          orderBy={orderBy}
          orientation={orientation}
        />
        <HeadCell
          heading="consultantName"
          onOrder={() => onOrder('consultantName')}
          orderBy={orderBy}
          orientation={orientation}
        />
        <HeadCell
          heading="folderCompletedAt"
          onOrder={() => onOrder('folderCompletedAt')}
          orderBy={orderBy}
          orientation={orientation}
        />
        <HeadCell
          heading="status"
          onOrder={() => onOrder('status')}
          orderBy={orderBy}
          orientation={orientation}
        />
      </TableRow>
    </TableHead>
  )
}
